import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { SWRConfig } from 'swr';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme/ThemeProvider';

dayjs.locale('ko');

/**
 * SWR 전역 설정 — 🔴 재호출 폭주 차단 (2026-07-30 서버 커넥션 고갈 대응)
 *
 * 설정이 없으면 SWR 기본값이 적용되는데, 대시보드는 화면 하나에서 useSWR 을 9개 띄우고
 * 그중 집계 API 는 응답이 수 초 걸린다. 기본값 그대로면 이렇게 무너진다:
 *   1) axios timeout(10s) 으로 클라가 끊어도 서버 쿼리는 계속 돌아 DB 커넥션을 계속 점유
 *   2) shouldRetryOnError=true + errorRetryCount 무제한 → 9개가 각자 무한 재시도
 *   3) revalidateOnFocus=true → 탭만 돌아와도 9개 전부 재호출
 *   → 커넥션 풀(20)이 마르고, 스토어 사용자 API 까지 동반 실패
 *
 * 그래서 재시도는 1회로 묶고, 포커스 재검증을 끄고, dedupe 창을 60초로 넓혔다.
 * (대시보드 지표는 서버에서도 3분 캐시라 초 단위 신선도가 필요 없다)
 */
const swrConfig = {
  errorRetryCount: 1,          // 무한 재시도 금지 (기본값: 무제한)
  errorRetryInterval: 10_000,  // 재시도 전 10초 대기 — 서버가 회복할 틈을 준다
  revalidateOnFocus: false,    // 탭 전환마다 전체 재호출 방지
  revalidateIfStale: false,    // 캐시가 있으면 자동 재검증 안 함 (새로고침은 명시적으로)
  dedupingInterval: 60_000,    // 같은 키 60초 내 중복 요청 합치기 (기본 2초)
  keepPreviousData: true,      // 재조회 중 화면 깜빡임 방지
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SWRConfig value={swrConfig}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </SWRConfig>
  </React.StrictMode>
);
